import React from 'react';
import {noop} from '../utils';
import {translate} from '@elements/translations';

const Pagination = ({ currentPage, totalPages, onChangePage = noop}) => {
    const handlePrevious = () => {
        if (currentPage > 1) {
            onChangePage(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onChangePage(currentPage + 1);
        }
    };

    const handlePageClick = (page) => {
        onChangePage(page);
    };

    const renderPageNumbers = () => {
        const pages = [];
        const startPage = Math.max(currentPage - 2, 1); // Start 3 pages before current
        const endPage = Math.min(currentPage + 2, totalPages); // End 3 pages after current

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <button
                    key={i}
                    onClick={() => handlePageClick(i)}
                    className={currentPage === i ? "active" : ""}
                >
                    {i}
                </button>
            );
        }
        return pages;
    };

    const renderPageSelectOptions = (totalPages, currentPage) => {
        const options = [];
        for (let i = 1; i <= totalPages; i++) {
            options.push(
                <option key={i} value={i} selected={currentPage === i}>{i}</option>
            );
        }
        return options;
    }
    return (
        <div className="filter-box filter-box--sm bg-white rounded">
            <div className="row align-items-center gx-md-5">
                <div className="col-4 small"></div>

                <div className="col-4">
                    <nav className="d-flex justify-content-center" aria-label="sr.pagination">
                        <ul className="pagination pagination-sm align-items-center font-bold">
                            <li className="page-item page-item--arrow">
                                <button className="page-link btn-no-styling" onClick={handlePrevious} disabled={currentPage === 1} aria-label={translate('sr.pagination.prev')}>
                                    <span className="icon icon-chevron icon-rotate-90 page-link__icon"></span>
                                </button>
                            </li>

                            <li className="page-item">
                                <div className="page-link text-dark font-default">
                                    <span className="d-none d-md-inline-block me-2">{translate('pagination.site')}</span>
                                    <select className={'form-select form-select--text'} onChange={(evt) => onChangePage(parseInt(evt.target.value))}>
                                        {renderPageSelectOptions(totalPages, currentPage)}
                                    </select> {translate('pagination.site-from')} {totalPages}
                                </div>
                            </li>

                            <li className="page-item page-item--arrow">
                                <button className="page-link btn-no-styling" onClick={handleNext} disabled={currentPage === totalPages} aria-label={translate('sr.pagination.next')}>
                                    <span className="icon icon-chevron icon-rotate-270 page-link__icon"></span>
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default Pagination;